import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from './routes';

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function ({ store }) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
  });

  Router.beforeEach((to, from, next) => {
    // Auto select location for authentication
    if (to.query.locationId) {
      store.commit('application/setLocation', to.query.locationId);
    }
    if (
      to.matched.some((record) => record.meta.requiresAuth)
      && store.state.application.isBooting
      && !store.getters['account/hasCredentials']
      && !store.getters['account/isAuthenticated']
    ) {
      // User is on a path that required auth => redirect to login screen
      next({ name: 'UserAuthentication', replace: true });
    }
    else if (
      to.matched.some((record) => record.meta.requiresAuth)
      && !store.state.application.isBooting
      && !store.getters['account/isAuthenticated']
    ) {
      // User is on a path that required auth => redirect to login screen
      next({ name: 'UserAuthentication', replace: true });
    }
    if (
      to.matched.some((record) => record.meta.requiresAdmin)
      && !store.state.application.isBooting
      && store.getters['account/hasCredentials']
      && store.getters['account/isAuthenticated']
      && store.getters['account/isNotificationUser']
    ) {
      // User is on a path that required auth => redirect to login screen
      next({ name: 'NotificationsIndex', replace: true });
    }
    else {
      next();
    }
  });

  return Router;
}
